export default "__VITE_ASSET__9bf10436__"